<div class="editor-mb">
  @if (isLoading) {
    <app-loader/>
  }
  <div
    class="row"
    app-mb-form
    [marketingBlockData]="marketingBlockData()"
    [marketingBlockFormGroup]="marketingBlockFormGroup()"
    [parentId]="parentId()"
    [isEditModeActive]="isEditModeActive()"
    [columnKey]="columnKey()"
    [noFirstData]="noFirstData()"
    [isActiveEditor]="isActiveEditor()"
    (updateMarketingBlock)="updateMarketingBlockData($event)"
  ></div>
  @if (columnKey() === 'websiteBackups') {
    <div>
      <div class="editor-mb-files">
        @for (file of websiteBackupFiles; track $index) {
          <app-file-card
            [fileCard]="{
              id: file.id,
              fileParams: file.file,
              fileType: 'WEBSITE_BACKUP',
              isEditModeActive: isEditModeActive(),
              shouldCheckImageType: false
            }"
            (handleDelete)="handleDeleteFile($event, file)"
          />
        }
      </div>
      <app-file-upload-card
        [fileUploadParams]="{
          parentId: marketingBlockData().id,
          recordId: marketingBlockData().id,
          type: `WEBSITE_BACKUP-${marketingBlockData().id}`,
          entityFileType: 'WEBSITE_BACKUP'
        }"
        [isEditModeActive]="isEditModeActive()"
        (attachFile)="attachFile($event)"
      />
    </div>
  }
  <button
    mat-fab
    extended
    color="primary"
    (click)="handleBackClick()"
  >
    <mat-icon>arrow_back</mat-icon>
    Назад
  </button>
</div>
